import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children }) => {
  const consent = localStorage.getItem("user_agreement");
  const isAuthenticated = useSelector((state) => {
    return state.auth.isAuthenticated
  });

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // if (consent !== "true") {
  //   return <Navigate to="/agreement" replace />;
  // }

  return children;
};

export default ProtectedRoute;
